export default __webpack_public_path__ + "static/media/survey2.f74a3fac.svg";